"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconFileCopy = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 22 22",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10,0 L-1.45519152e-11,0 L-1.45519152e-11,20 L9,20 C8.59,19.75 8.2,19.44 7.86,19.1 C7.53,18.77 7.25,18.4 7,18 L2,18 L2,2 L9,2 L9,7 L14,7 L14,8.18 C14.71,8.34 15.39,8.61 16,9 L16,6 L10,0 M16.31,16.9 C17.64,14.79 17,12 14.91,10.68 C12.8,9.35 10,10 8.69,12.08 C7.35,14.19 8,16.97 10.09,18.3 C11.55,19.23 13.41,19.23 14.88,18.32 L18,21.39 L19.39,20 L16.31,16.9 M12.5,17 C11.1192881,17 10,15.8807119 10,14.5 C10,13.1192881 11.1192881,12 12.5,12 C13.8807119,12 15,13.1192881 15,14.5 C15,15.8807119 13.8807119,17 12.5,17 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconFileCopy')(IconFileCopy);